// extracted by mini-css-extract-plugin
module.exports =  {"root":"qGDEuS","value":"QHWi1V","divider":"PW8Iwu"};